import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { PMStatus } from '../../model';

enum Status { ARRANGING = 'Arranging', CONFIRMED = 'Confirmed', COMPLETED = 'Completed', CANCELLED = 'Cancelled', UNKNOWN = 'Unknown'}

@Directive({
  selector: '[appPMStatusNum2statusName]'
})
export class PMStatusNum2statusNameDirective implements OnInit {

  @Input() status: any;

  constructor(private el: ElementRef) { }

  getStatusNameFromStatusNum(): Status {
    if (this.status === PMStatus.arranging ) {
      return Status.ARRANGING;
    } else if (this.status === PMStatus.confirmed ) {
      return Status.CONFIRMED;
    } else if (this.status === PMStatus.completed ) {
      return Status.COMPLETED;
    } else if (this.status === PMStatus.cancelled ) {
      return Status.CANCELLED;
    } else {
      return Status.UNKNOWN;
    }
  }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    nativeElement.innerText = this.getStatusNameFromStatusNum();
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/pm-statusnum2statusname/pm-statusnum2statusname.directive.ts